module.exports = __webpack_public_path__ + "img/box_bk_line.ff4ebdc8.gif";